<template>
  <BaseAction>
    <SecondaryButton @click.native="openSubmitWorkers" color="primary">
      <div class="d-flex align-center">
        <inline-svg
          :src="require('@/assets/svg/account_group.svg')"
          width="40"
        />
        <v-icon size="1rem">
          mdi-arrow-right
        </v-icon>
      </div>
      Submit Workers
    </SecondaryButton>
    <SubmitWorkers
      v-if="submitWorkersOpen"
      :isOpen="submitWorkersOpen"
      @close="closeSubmitWorkers"
    />
  </BaseAction>
</template>

<script>
import SubmitWorkers from "@/views/bookings/components/SubmitWorkers/SubmitWorkers";
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import InlineSvg from "vue-inline-svg";

export default {
  name: "SubmitWorkerAction",
  components: { BaseAction, SecondaryButton, SubmitWorkers, InlineSvg },
  data() {
    return {
      submitWorkersOpen: false
    };
  },
  methods: {
    openSubmitWorkers() {
      this.submitWorkersOpen = true;
    },
    closeSubmitWorkers() {
      this.submitWorkersOpen = false;
    }
  }
};
</script>

<style scoped></style>
